import { ArrowLeft, Bell, Bird, X } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ModalOverlay } from './ModalOverlay';
import { PartsSyncStatus } from './PartsSyncStatus';
import { NaveNotifications } from './NaveNotifications';

/** Marca y acceso a notificaciones compartidos por todas las cabeceras. */
export function AppHeaderContent({
  backTo,
  backLabel = 'Inicio',
}: { backTo?: string; backLabel?: string } = {}) {
  const { t } = useTranslation();
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  return (
    <div className="ui-app-header">
      {backTo ? (
        <Link to={backTo} className="nave-back">
          <ArrowLeft size={19} aria-hidden />
          {backLabel}
        </Link>
      ) : (
        <div className="ui-brand">
          <Bird aria-hidden strokeWidth={1.8} />
          <span>{t('app.name')}</span>
        </div>
      )}
      <div className="ui-header-tools">
        <PartsSyncStatus />
        <button
          type="button"
          aria-label={t('app.notificaciones')}
          className="ui-icon-button"
          aria-haspopup="dialog"
          aria-expanded={notificationsOpen}
          onClick={() => setNotificationsOpen(true)}
        >
          <Bell size={22} strokeWidth={1.8} aria-hidden />
        </button>
      </div>
      {notificationsOpen && (
        <ModalOverlay
          placement="bottom"
          onBackdrop={() => setNotificationsOpen(false)}
          ariaLabelledby="notifications-title"
          className="max-w-md"
        >
          <header className="flex items-center justify-between gap-3">
            <h2 id="notifications-title" className="ui-page-title">
              Notificaciones
            </h2>
            <button
              type="button"
              className="ui-icon-button ui-close-button"
              aria-label="Cerrar notificaciones"
              onClick={() => setNotificationsOpen(false)}
            >
              <X size={22} aria-hidden />
            </button>
          </header>
          <NaveNotifications onNavigate={() => setNotificationsOpen(false)} />
          <Link to="/" className="ui-primary w-full" onClick={() => setNotificationsOpen(false)}>
            Ver naves
          </Link>
        </ModalOverlay>
      )}
    </div>
  );
}
